// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gyyxbS9mk5fybqrw8OzPP"};